import React, { useEffect, useState } from 'react';
import EnhancedTable from '../../components/table';
import Config from '../../config';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import TestProgress from './progressbar';
import SearchBox from '../../components/searchbox';
import Helper from '../../helpers';
import { getCompanyNames } from '../../helpers';
import { withRouter } from "react-router";
import DownloadButton from '../../components/download_button';
import FileSaverBase from 'filesaver.js-npm';
import Papa from 'papaparse';
import axios from 'axios';

// EnhancedTable is a loosely-typed .js default export; cast to a permissive
// component type so this .tsx file builds (mirrors the pattern used
// elsewhere in this migration, e.g. settings/v2/scheduled_tasks.tsx).
const TypedEnhancedTable = EnhancedTable as React.ComponentType<any>;

// filesaver.js-npm's type declarations resolve to `() => void`, so `.saveAs`
// isn't visible on the typed import; cast at the import boundary (same
// pattern as documents/standards.tsx and inventory/v1/product.tsx).
const FileSaver: any = FileSaverBase;

type TestingOverviewProps = {
    setTitle?: (title: string) => void;
    history: { replace: (location: { pathname: string; search: string }) => void };
    location: { pathname: string; search?: string };
};

const TestingOverview = (props: TestingOverviewProps) => {
    const { setTitle, history, location } = props;
    const [term, setTerm] = useState('');
    const [termValue, setTermValue] = useState('');

    useEffect(() => {
        if(setTitle) {
            setTitle('Testing');
        }
    }, [setTitle]);

    const onEnter = async (e: React.SyntheticEvent<HTMLInputElement>) => {
        let nextTerm = e.currentTarget.value;
        setTerm(nextTerm);
        new Helper().setTermInUrl(nextTerm, history, location);
    };
    const exportCsv = async () => {
        let header = ['Company Name', 'Complete Test Cases', 'Total Test Cases'];
        let pageSize = 50;
        let page = (await axios.get(Config.api + `/odata/Company/VwTestingProgress?$top=${pageSize}&$skip=0&$orderby=PartnerCompanyName asc`)).data.value;
        let progress = [...page];
        let i = 1;
        while(page.length === pageSize && i < 100){
            page = (await axios.get(Config.api + `/odata/Company/VwTestingProgress?$top=${pageSize}&$skip=${progress.length}&$orderby=PartnerCompanyName asc`)).data.value;
            progress = progress.concat(page);
            i++;
        }
        let rows = [header].concat(progress.map((r: any) => ([r.PartnerCompanyName, r.PassedTests, r.TotalTests])));
        let output = Papa.unparse(rows);
        let blob = new Blob([output], { type: "text/csv" });
        FileSaver.saveAs(blob, 'testing_status.csv');
    };

    var config: any = {
            url: Config.api + "/odata/Company/VwTestingProgress",
            columns: [
              { id: "PartnerCoId", hidden: true},
              { id: 'PartnerCompanyName', filterable: true, sortable: true, label: 'Partner', width: '20em', getOptions: getCompanyNames },
              { id: 'TotalTests', type: 'number', hidden: true },
              { id: 'PassedTests', type: 'number', filterable: true, sortable: true, label: 'Progress', template: (value: any, row: any) => {
                  return <TestProgress style={{paddingLeft: '1em', paddingRight: '1em', paddingTop: '0.5em', paddingBottom: '0.5em'}} passed={row.PassedTests} total={row.TotalTests} completeText='Testing Complete'/>;
              }},
              { command: 'actions', template: (value: any, row: any) => <Button variant='outlined' size='small' component={Link} to={`/testing/cases?partner=${row.PartnerCoId}`}>View</Button>, width: '10em'}
          ],
          term: term,
          order: 'asc',
          orderBy: 'PartnerCompanyName',
          keyField: 'PartnerCoId',
          pageSize: 20,
          pageSizes: [10, 20, 50],
          title: 'Testing Status',
          actions: <div style={{marginTop: 'auto', marginBottom: 'auto', display: 'flex', flex: '1'}}>
            <div style={{marginRight: '1em'}}>
                <DownloadButton onClick={exportCsv} variant='outlined'>Export</DownloadButton>
            </div>
            <div>
                <SearchBox placeholder="Search" onEnter={onEnter} handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setTermValue(e.currentTarget.value)} term={termValue}/>
            </div>
            </div>
      };
    return <TypedEnhancedTable config={config}/>;
};

// withRouter's TS overload narrows the wrapped props to RouteComponentProps;
// cast to any at the boundary (same pattern as documents/standards.tsx etc.).
// withRouter also strips the custom setTitle prop from the wrapped signature,
// so cast the *result* to any too (App.tsx passes setTitle). Same as search.tsx.
export default withRouter(TestingOverview as any) as any;
